import type { SVGProps } from "react";

export function Rotate(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0645 1.47264C12.3557 1.17812 12.8306 1.17546 13.1251 1.46671L15.294 3.61151C15.5755 3.88986 15.5922 4.33904 15.3321 4.6375L13.1632 7.12663C12.8911 7.43892 12.4173 7.47149 12.1051 7.19938C11.7928 6.92726 11.7602 6.45351 12.0323 6.14122L13.1184 4.89479H10C6.81642 4.89479 4.25 7.44464 4.25 10.5724C4.25 13.7002 6.81642 16.25 10 16.25C13.1836 16.25 15.75 13.7002 15.75 10.5724C15.75 10.1582 16.0858 9.8224 16.5 9.8224C16.9142 9.8224 17.25 10.1582 17.25 10.5724C17.25 14.5444 13.9961 17.75 10 17.75C6.00388 17.75 2.75 14.5444 2.75 10.5724C2.75 6.60042 6.00388 3.39479 10 3.39479H12.9416L12.0704 2.53329C11.7759 2.24204 11.7732 1.76717 12.0645 1.47264Z"
        fill="currentColor"
      />
    </svg>
  );
}
